import axios from '@fs/zion-axios'
import useProfile from './useProfile'

const profileUrl = '/service/user/profile/users/CURRENT'

export default function useHelperPin() {
  const { profile, profileLoading: helperPinLoading, updateLocalProfile } = useProfile()

  const handleChangeHelperPin = async (value) => {
    await axios.patch(profileUrl, { helperPin: { value, visibility: 'PRIVATE' } })
    updateLocalProfile({ helperPin: { value, visibility: 'PRIVATE' } })
  }

  return {
    helperPin: profile?.helperPin?.value ?? '',
    helperPinLoading,
    handleChangeHelperPin,
  }
}
